import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { CreateBoxViewStore } from 'modules/product/stores';
import { CreateBoxTemplate } from 'themes/modules/product/pages';

@setCurrentView(rootStore => new CreateBoxViewStore(rootStore), 'createBoxViewStore')
@observer
class CreateBox extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <CreateBoxTemplate {...this.props} />;
	}
}

export default observer(CreateBox);



// WEBPACK FOOTER //
// ./src/modules/product/pages/CreateBox.jsx